export default __webpack_public_path__ + "static/assets/networkRailAngelTrains.4589e6ba31a409c6824cafb6216858e5.png";